import { useLayer } from '@coursera-web/statsig';

/**
 * Gates the header help dropdown behind the `boost-chatbot-header-everywhere-layer`
 * Statsig experiment (HOME-4951). Returns true when the help dropdown should be shown.
 */
const useShouldShowHelpDropdown = () => {
  const layer = useLayer('boost-chatbot-header-everywhere-layer');
  return layer.get('show-boost-chatbot', false);
};

export default useShouldShowHelpDropdown;
